var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2377_166",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0H0.5V20H16.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2377_166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3984 1.44922V2.79922C11.3984 4.07182 11.3984 4.70812 11.7944 5.10322C12.1886 5.49922 12.8249 5.49922 14.0984 5.49922H15.4484",
    stroke: "#2B2B67",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1 9.1H12.3M5.1 11.8H12.3M5.1 14.5H8.853M1.5 13.6V6.4C1.5 3.8548 1.5 2.5813 2.2911 1.7911C3.0813 1 4.3548 1 6.9 1H10.6548C11.022 1 11.2065 1 11.3721 1.0684C11.5368 1.1368 11.6673 1.2664 11.9274 1.5274L15.3726 4.9726C15.6336 5.2336 15.7632 5.3632 15.8316 5.5288C15.9 5.6935 15.9 5.878 15.9 6.2452V13.6C15.9 16.1452 15.9 17.4187 15.1089 18.2089C14.3187 19 13.0452 19 10.5 19H6.9C4.3548 19 3.0813 19 2.2911 18.2089C1.5 17.4187 1.5 16.1452 1.5 13.6Z",
    stroke: "#2B2B67",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.2b5437a2ba082c98fb29ef07c64b8ef8.svg";
export { ForwardRef as ReactComponent };